export const isClipboardSupported = () => navigator?.clipboard != null;

/**
 * 인자로 받은 텍스트를 클립보드에 복사합니다.
 *
 * @example
 * ```ts
 * const result = await copyToClipboard('하이');
 * if (result) {
 *   console.log('클립보드에 복사 성공');
 * } else {
 *   console.log('클립보드에 복사 실패');
 * }
 * ```
 */
export const copyToClipboard = (text: string) => {
  return new Promise<boolean>(async (resolve) => {
    if (isClipboardSupported()) {
      await navigator.clipboard.writeText(text);
      resolve(true);

      return;
    }

    resolve(false);
  });
};

export default copyToClipboard;
